import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { getApp, getLogicalRing, getForest } from 'owa-config';

export default function createAlchemyClientContext(
    userConfig: OwaUserConfiguration,
    invokedBy: string
) {
    let sessionStart;
    if (window.performance) {
        let sessionStartTime = new Date();
        sessionStartTime.setTime(window.performance.timing.fetchStart);
        sessionStart = String(sessionStartTime);
    }

    const clientContext = {
        Country: userConfig.UserOptions.TimeZone,
        Platform: window.navigator.platform,
        BrowserLanguage: window.navigator.language,
        MbxCulture: userConfig.SessionSettings.UserCulture,
        OwaLayout: getApp(),
        OwaUtcStartTime: sessionStart,
        Ring: getLogicalRing(),
        Forest: getForest(),
        InvokedBy: invokedBy,
    };

    return JSON.stringify(clientContext);
}
